import type { VyDate } from '@vy/utils';
import { extract, parseNumber, validateArray, validateEnum, vyDate } from '@vy/utils';
import { unix } from '@vy/utils';

export function formatIdObjectsParam(idObjects: { id: string }[]) {
  const objectIds = extract(idObjects, 'id');

  return objectIds.join(',');
}

export function serializeStringArrayParam(strings: string[] = []): string {
  return strings.join(',');
}

export function deserializeStringArrayParam(paramString: string): string[] {
  return paramString.split(',');
}

export function deseralizeIt<T>(params: T[] | T[]): T[] {
  return params;
}

export function serializeDateParam(date: VyDate): string {
  return date.unix().toString();
}

export function deserializeDateParam(paramString: string): VyDate | null {
  const parsedNumber = parseNumber(paramString);

  return parsedNumber ? vyDate(unix(parsedNumber)) : null;
}

export function formatStringParam(string: string) {
  return string;
}

export function serializeNumberParam(number: number): string {
  return String(number);
}

export function deserializeNumberParam(paramString: string): number | null {
  const parsedNumber = parseNumber(paramString);

  return parsedNumber ? parsedNumber : null;
}

export function deserializeEnumParam<Type extends object>(enumObject: Type) {
  return (value: unknown) => {
    validateEnum(value, enumObject);

    return value;
  };
}

export function deserializeEnumArrayParam<Type extends object>(enumObject: Type) {
  return (value: string) => {
    const valueAsArray = deserializeStringArrayParam(value);
    validateArray(valueAsArray);

    return valueAsArray.map((item) => {
      validateEnum(item, enumObject);

      return item;
    });
  };
}
